/**
 * WorkPackageEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PersonEntity } from "../PersonEntity";
import { WorkPackageDescriptionEntity } from "../WorkPackageDescriptionEntity";
import { PlanningEventEntity } from "../PlanningEventEntity";
import { BugEntity } from "../BugEntity";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
import { DocumentEntity } from "../DocumentEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
declare global {
    interface EntityTypeMap {
        WorkPackage: WorkPackageEntity;
    }
}
export abstract class WorkPackageGeneratedEntity extends BaseEntity {
    public abstract workPackageId: string;
    public abstract templateId: string | null;
    public abstract index: string;
    public abstract name: string;
    public abstract color: number;
    public abstract displayName: string;
    public abstract project: ProjectEntity;
    public abstract contact: PersonEntity | null;
    public abstract readonly descriptions: ReadonlyArray<WorkPackageDescriptionEntity>;
    public abstract readonly planningEvents: ReadonlyArray<PlanningEventEntity>;
    public abstract readonly bugs: ReadonlyArray<BugEntity>;
    public abstract remarkCategory: RemarkCategoryEntity | null;
    public abstract readonly documents: ReadonlyArray<DocumentEntity>;
}
